(function () {
  const modal = document.getElementById('crvSizeGuide');
  if (!modal) return;

  const dialog = modal.querySelector('.crv-modal__dialog');
  const closeEls = modal.querySelectorAll('[data-crv-close]');
  const tabs = Array.from(modal.querySelectorAll('[data-crv-tab]'));
  const panels = Array.from(modal.querySelectorAll('[data-crv-panel]'));

  let lastFocusedEl = null;

  function setActive(guideKey) {
    tabs.forEach(btn => {
      const active = btn.getAttribute('data-crv-tab') === guideKey;
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(p => {
      const active = p.getAttribute('data-crv-panel') === guideKey;
      p.hidden = !active;
    });

    const titleMap = {
      bracelet: 'Guia de tamanhos: Pulseira',
      necklace: 'Guia de tamanhos: Colar',
      ring: 'Guia de tamanhos: Anel'
    };

    const subtitleMap = {
      bracelet: 'Meça seu pulso e encontre o caimento ideal.',
      necklace: 'Escolha o comprimento conforme o caimento no corpo.',
      ring: 'Descubra seu aro com uma medição simples em casa.'
    };

    const title = modal.querySelector('#crvModalTitle');
    const subtitle = modal.querySelector('#crvModalSubtitle');
    if (title) title.textContent = titleMap[guideKey] || 'Guia de tamanhos';
    if (subtitle) subtitle.textContent = subtitleMap[guideKey] || 'Veja como medir e escolher.';
  }

  function openModal(guideKey) {
    lastFocusedEl = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    setActive(guideKey || 'bracelet');

    setTimeout(() => dialog && dialog.focus(), 0);
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
      lastFocusedEl.focus();
    }
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.crv-sizeguide-trigger');
    if (!trigger) return;

    e.preventDefault();
    const guideKey = trigger.getAttribute('data-guide') || 'bracelet';
    openModal(guideKey);
  });

  tabs.forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.getAttribute('data-crv-tab');
      setActive(key);
    });
  });

  closeEls.forEach(el => el.addEventListener('click', closeModal));

  document.addEventListener('keydown', function (e) {
    const isOpen = modal.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;
    if (e.key === 'Escape') closeModal();
  });

  modal.addEventListener('keydown', function (e) {
    const isOpen = modal.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;
    if (e.key !== 'Tab') return;

    const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    const list = Array.from(focusable).filter(el => !el.disabled && el.offsetParent !== null);
    if (!list.length) return;

    const first = list[0];
    const last = list[list.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
